const TABLET_VERSION = 1023
const MOBILE_VERSION = 860


export {TABLET_VERSION, MOBILE_VERSION}
